import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export default function Header() {
  // 다국어
  const { t } = useTranslation();

  return (
    <header>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center', // 세로 중앙정렬
          justifyContent: {
            xs: 'center',
            sm: 'start'
          },
          height: {
            xs: '56px',
            sm: '64px'
          },
          width: '100%',
          maxWidth: '1920px',
          margin: 'auto',
          paddingX: {
            xs: '16px',
            sm: '24px'
          },
          paddingTop: 0.5
        }}
      >
        <Box
          component={Link}
          to="/"
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems="center"
          gap={{ xs: 0, sm: 2 }}
          whiteSpace="nowrap"
          sx={{
            textDecoration: 'none', // 링크 스타일 제거
            color: 'inherit' // 텍스트 컬러를 상속
          }}
        >
          <Box width={{ xs: 'auto', sm: '100%' }} maxWidth="152px" height={{ xs: '20px', sm: '100%' }}>
            <img src="/images/ulvac_logo.png" alt="ulvac_logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          </Box>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Box fontSize={{ xs: '16px', sm: '24px' }} sx={{ fontWeight: 'bold' }}>
              {t('ulvac_korea')}
            </Box>
            <Box fontSize={{ xs: '16px', sm: '24px' }}> {t('visitor_registration_system')}</Box>
          </Box>
        </Box>
      </Box>
    </header>
  );
}
